<template>
  <div>
    <h1>Incidències a l'aula</h1>
    <AddTicket/>
    <UserTicketsTable :classroom="true" style="margin-top: 2%;"/>
  </div>
</template>

<script>
import UserTicketsTable from '@/components/UserTicketsTable'
import AddTicket from '@/components/AddTicket'

export default {
  components: {
    UserTicketsTable,
    AddTicket
  }
}
</script>
